<template>
  <div id="filter-dropdown" v-click-outside="hide">
    <button v-if="name" class="sc-btn" @click="showBox = !showBox">
      {{ name }}
    </button>
    <img
      v-else
      src="/static/icons/iconfilterblack.svg"
      class="icon pointer"
      @click="showBox = !showBox"
    />

    <div v-if="showBox" class="filter-box">
      <div class="header">
        {{ header }}
      </div>
      <div class="body">
        <div v-for="row in rows" :key="row.key" class="item">
          <label v-if="type === 'radio'" class="select-input">
            {{ row.value }}
            <input
              v-model="radioPicker"
              :value="row.key"
              type="radio"
              name="input"
            />
            <span class="checkmark radio"></span>
          </label>
          <label v-if="type === 'checkbox'" class="select-input">
            {{ row.value }}
            <input
              v-model="checkboxPicker"
              :value="row.key"
              type="checkbox"
              name="input"
            />
            <span class="checkmark checkbox"></span>
          </label>
        </div>
      </div>
      <div class="footer text-end">
        <a class="pointer" @click="submit()">ตกลง</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelperDropdown",
  props: {
    rows: {
      type: null,
      default: undefined,
    },
    type: {
      type: null,
      default: undefined,
    },
    header: {
      type: null,
      default: undefined,
    },
    name: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      showBox: false,
      radioPicker: "",
      checkboxPicker: [],
    }
  },
  methods: {
    submit() {
      if (this.type === "radio") {
        this.$emit("filterSubmit", this.radioPicker)
      } else if (this.type === "checkbox") {
        this.$emit("filterSubmit", this.checkboxPicker)
      }
      this.showBox = false
    },
    hide() {
      this.showBox = false
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  border: solid 1px #e0e0e0;
  padding: 6px;

  position: relative;
}
.sc-btn {
  height: 34px;
  border-radius: 5px;
  background: #fff;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;
}
.filter-box {
  position: fixed;
  padding: 15px;
  margin-top: 5px;
  z-index: 89;

  border: solid 1px #e0e0e0;
  border-radius: 5px;
  background: #fff;

  .header {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: -0.1px;
    color: #000000;
    padding-bottom: 10px;
  }
  .body {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;

    .item {
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.36;
      letter-spacing: -0.1px;
      color: #000000;
    }
  }
  .footer {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: #e27024;
  }
}
</style>
